import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import FechaReporte from "./FechaReporte.jsx"

const TabsWithAnimatedButtons = ({
  selectedDate,
  setSelectedDate,
  activeTab,
  setActiveTab
}) => {
  const [range, setRange] = useState(false);
  const [selectedDate2, setSelectedDate2] = useState(new Date());
  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };
  useEffect(() => {
    if (activeTab !== "Dia") {
      setRange(true)
    } else {
      setRange(false)
    }
  }, [activeTab])
  return (
    <DivCOntectGeneral>
      <ContectFecha  >
        {
          range ?
            <>
              <DateText>
                Desde
              </DateText>
              <FechaReporte
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
              />
              <DateText>
                Hasta
              </DateText>
              <FechaReporte
                selectedDate={selectedDate2}
                setSelectedDate={setSelectedDate2}
              />
            </>
            :
            <FechaReporte
              selectedDate={selectedDate}
              setSelectedDate={setSelectedDate}
            />
        }

      </ContectFecha>
      <DivBtnsFilter>
        <BtnsFilter
          active={activeTab === "Dia"}
          onClick={() => handleTabClick("Dia")}
        >
          Día
        </BtnsFilter>
        <BtnsFilter
          active={activeTab === "Semana"}
          onClick={() => handleTabClick("Semana")}
        >
          Semana
        </BtnsFilter>
        <BtnsFilter
          active={activeTab === "Mes"}
          onClick={() => handleTabClick("Mes")}
        >
          Mes
        </BtnsFilter>
        <BtnsFilter
          active={activeTab === "Anio"}
          onClick={() => handleTabClick("Anio")}
        >
          Año
        </BtnsFilter>

      </DivBtnsFilter>
      <DivBtnsFilter
        style={{
          position: "relative",
          top: "-50px",
          backgroundColor: "Transparent"
        }}
      >
        <TabIndicator activeTab={activeTab} />
      </DivBtnsFilter>
    </DivCOntectGeneral>
  );
};

export default TabsWithAnimatedButtons;

const DateText = styled.span`
  color: #003049;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 16px;
  cursor: pointer;
  transition: border-color 0.3s ease;
  box-sizing: border-box;
`;

const ContectFecha = styled.div`
  width: -webkit-fill-available;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  margin-bottom:32px;
`;

const DivCOntectGeneral = styled.div`
  width:100%;
  display: inline-block;
`;

const BtnsFilter = styled.div`
  width: 25%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  height: 40px;
  color: ${({ active }) => (active ? '#FFFFFF' : '#003049')};
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 16px;
  cursor: pointer;
  position: relative;
  z-index:1;
  transition: all 0.2s;
  &:hover {
    text-decoration: underline;
  }
`;

const DivBtnsFilter = styled.div`
  width: -webkit-fill-available;
  margin: 10px 25%;
  display: flex;
  flex-direction: row;
  border-radius: 8px;
  height: 40px;
  background-color: #ffffff;
  min-height: 40px;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
`;

const TabIndicator = styled.div`
  position: relative;
  bottom: 0;
  left: 0;
  width: 25%;
  height: 100%;
  z-index:1;
  border-radius: 8px;
  background-color: #003049;
  transition: transform 0.3s ease-in-out;
  transform: ${({ activeTab }) => {
    switch (activeTab) {
      case 'Dia':
        return 'translateX(0%)';
      case 'Semana':
        return 'translateX(100%)';
      case 'Mes':
        return 'translateX(200%)';
      case 'Anio':
        return 'translateX(300%)';
      default:
        return 'translateX(0%)';
    }
  }};
  z-index: 0;
  &:before {
    content: '';
    position: absolute;
    bottom: -4px;
    left: 0;
    width: 100%;
    height: 0px;
    background-color: #003049;
    animation: wave 0.3s ease-in-out;
  }
  @keyframes wave {
    0% {
      transform: scaleX(0);
    }
    50% {
      transform: scaleX(1);
    }
    100% {
      transform: scaleX(0);
    }
  }
`;
